<template lang="html">
  <div class="home">
    <div class="navbar">
      <ul class="navtab">
        <li class="active" @click="topath('/home')">直播课<span></span></li>
        <li @click="topath('/tgfc')">投顾风采<span></span></li>
        <!-- <li @click="topath('/mrcb')">每日晨报<span></span></li> -->
        <li @click="topath('/zjhz')">战绩汇总<span></span></li>
      </ul>
    </div>
    <div class="zbj">
      <!-- <gs:video-vod id="videoComponent" site="tzkt.gensee.com" ctx="webcast" v-bind:ownerid="id" uid="105581"
                    uname="user"/> -->
      <div id="playbackPlayer"></div>
    </div>
    <div class="liveprompt" :class="status==3?'active':''">
      <div class="head">
        <img :src="head">
      </div>
      <div class="text">
        <p><span>{{playtea}}</span>正在直播({{playtime}}) <img src="../../assets/live.png"></p>
        <p class="title">{{playclass}}</p>
      </div>
    </div>
    <div class="tab">
      <ul class="tablist">
        <li :class="{active:shownum==''}" @click="show('')">
          评论
          <span></span>
        </li>
        <li :class="{active:shownum=='1'}" @click="show('1')">
          节目单
          <span></span>
        </li>
        <li :class="{active:shownum=='2'}" @click="show('2')">
          点播
          <span></span>
        </li>
      </ul>
    </div>
    <!--评论-->
    <div class="comment" v-if="shownum==''" id="comment">
      <ul class="commentlist">
        <li v-for="item in anArray">
          <div class="uhead" v-if="item.head">
            <img :src="'/static/img/header/'+item.head+'@1x.png'">
          </div>
          <div class="uhead" v-else>
            <img src="../../assets/demo.png">
          </div>
          <div class="uinfo">
            <div class="top">
              <p class="uname">{{item.nickname}}</p>
              <p class="time">{{item.create_time | format }}</p>
            </div>
            <p class="ucommment" v-if="item.type==='img'"><img
              :src="'https://mai-ydgpzbj.ydtg.com.cn/static/index/img/faces/'+item.question+'@2x.png'"></p>
            <p class="ucommment" v-else>{{item.question}}</p>
          </div>
        </li>
      </ul>
    </div>
    <!--节目单-->
    <div class="program" v-if="shownum=='1'">
      <ul class="programlist">
        <li v-for="item in classArr">
          <div class="time">
            {{item.start}}-{{item.end}}
          </div>
          <div class="name">
            <span>{{item.nickname}}</span>
            {{item.title}}
          </div>
          <div class="back" @click="goplay(item.url)" v-if="item.status==3">{{item.status| formatStatus}}</div>
          <div :class="item.status == 1?'living':'back'" v-else>{{item.status|formatStatus}}</div>
        </li>
      </ul>
    </div>
    <div class="program" v-if="shownum=='2'">
      <ul class="programlist">
        <li v-for="item in videos" :class="{live:item.status==1}">
          <div class="time">
            {{item.recordStartTime | format}}-{{item.recordEndTime | format}}
          </div>
          <div class="name">
            <span>{{item.nickname}}</span>
            {{item.title}}
          </div>
          <div class="back" @click="goplay2(item.vid)">观看</div>

        </li>
      </ul>
    </div>
    <!--发表评论-->
    <div class="publish" v-if="shownum==''">
      <span class="askmarket" @click="askShow">问行情</span>
      <span class="shares" @click="sharesShow">诊股票</span>
      <input type="text" v-model="comment" v-reset-page class="question" placeholder="输入股票代码" @blur="setHeight">
      <span @click='send' class="submit1 speak">发送</span>
    </div>
    <!--遮罩层-->
    <div class="layer" v-if="dialogshow"></div>
    <!--问行情弹框-->
    <div class="askmarket_detail" v-if="askmarketshow">
      <p class="title">问行情</p>
      <div v-for="item in questions">
        <p class="option" @click="ask(item.question,1,'gpdm')">{{item.question}}</p>
      </div>
      <p class="close">
        <!-- <span class="line"></span> -->
        <img src="../../assets/img/close.png" @click="hide(1)">
      </p>
    </div>
    <!--诊股票弹框-->
    <div class="consultation_stock" v-if="stockShow">
      <p class="title">诊股票</p>
      <p class="option" v-for="item in shares" @click="fillInCode(item.txt,item.id)">{{item.txt}}</p>
      <p class="close">
        <!-- <span class="line"></span> -->
        <img src="../../assets/img/close.png" @click="hide(2)">
      </p>
    </div>
    <!--填写股票代码弹框-->
    <div class="fillIn" v-if="fillShow">
      <p class="title">诊股票</p>
      <p class="option">{{question}}</p>
      <p class="input" v-if="id==3">
        <input type="text" v-reset-page v-model="buyprice" placeholder="请输入买入价格">
      </p>
      <p class="input">
        <input type="text" v-reset-page v-model="stockcode" placeholder="请输入股票代码">
      </p>
      <p class="btn">
        <span class="previous" @click="lastStep">上一步</span>
        <span class="sendcode" @click="tijiao()">发送</span>
      </p>
      <p class="close">
        <!-- <span class="line"></span> -->
        <img src="../../assets/img/close.png" @click="hide(3)">
      </p>
    </div>
  </div>
</template>

<script>
  import moment from 'moment'
  import service from './js/getmsg'
  import * as api from '../../api/api.js'
  import {YDCLOUD} from '../../tool/ydCloudCommon'

  export default {
    name: 'home',
    data() {
      return {
        shownum: '1',
        comment: '',
        classArr: service.classArr,
        anArray: service.msgArr,
        words: [],
        videos: [],
        user: '',
        rid: 4,
        roomId: 'E4D4B20B348BDB2C9C33DC5901307461',
        status: '',
        head: '/static/img/head.png',
        playtea: '',
        playtime: '',
        playclass: '',
        shares: [
          {
            'id': '1',
            'txt': '短期走势'
          },
          {
            'id': '2',
            'txt': '该不该持有'
          },
          {
            'id': '3',
            'txt': '应如何操作'
          }
        ],
        dialogshow: false,
        askmarketshow: false,
        stockShow: false,
        question: '',
        fillShow: false,
        id: '',
        buyprice: '',
        stockcode: ''
      }
    },
    directives: {
      resetPage: {
        inserted: function (el) {
          document.body.addEventListener('focusout', () => {
            if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
              //软键盘收起的事件处理
              setTimeout(() => {
                const scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0
                window.scrollTo(0, Math.max(scrollHeight - 1, 0));
              }, 100)
            }
          });
        }
      }
    },
    filters: {
      /*解析时间戳*/
      format: function (value) {
        return moment(parseInt(value)).format("MM-DD HH:mm");
      },
      formatStatus: function (value) {
        return value == 1 ? '直播中' : value == 2 ? '尚未开始' : '回看';
      }
    },
    methods: {
      show: function (num) {
        this.shownum = num;
        if (num == 1) {
          var _this = this;
          setTimeout(function () {
            _this.classArr = service.classArr
          }, 500)
        }
        if (num == 2) {
          this.gethis();
        }
        this.setHeight();
      },
      goplay: function (url) {
        this.$router.push({path: '/video', query: {id: url}});
        window.location.reload();
      },
      goplay2: function (url) {
        this.$router.push({path: '/hisvideo', query: {id: url}});
        window.location.reload();
      },
      topath: function (url) {
        this.$router.push(url);
      },
      /*行情问题提问*/
      ask: function (question, num) {
        var username = this.user.nickname;
        var nickname = this.user.nickname;
        this.$http.post(api.CHAT, {
          question: question,
          username: username,
          nickname: nickname,
          type: 'hq',
          code: '',
          head: '',
          rid: this.rid,
        }).then(function (data) {
          if (data['data']['code'] != 10000) {
            this.$dialog.toast({mes: data['data']['msg'], timeout: 1500});
            //清空输入框中的数据
            this.stockcode = '';
            this.buyprice = '';
            return;
          } else {
            this.hide(num);  //关闭弹窗
            this.hide(3);
            //清空输入框中的数据
            this.stockcode = '';
            this.buyprice = '';
          }
        })
      },
      /*诊股票*/
      tijiao: function () {
        var str = '';
        var question = this.question;
        var code = this.stockcode;
        var money = this.buyprice;
        if (code.length == 0) {
          this.$dialog.toast({mes: "输入框不能为空", timeout: 1500});
          return;
        }
        if (this.id == 3) {
          if (money.length == 0) {
            this.$dialog.toast({mes: "输入框不能为空", timeout: 1500});
            return;
          }
          if (!$.isNumeric(money)) {
            this.$dialog.toast({mes: "股票价格格式不正确", timeout: 1500});
            this.stockcode = '';
            this.buyprice = '';
            return false;
          }
        }
        if (money) {
          str = money + "元买入" + code + question;
        } else {
          str = code + question;
        }
        var username = this.user.nickname;
        var nickname = this.user.nickname;
        this.$http.post(api.CHAT, {
          question: str,
          username: username,
          nickname: nickname,
          type: 'zgp',
          code: code,
          head: '',
          rid: this.rid,
        }).then(function (data) {
          if (data['data']['code'] != 10000) {
            this.$dialog.toast({mes: data['data']['msg'], timeout: 1500});
            //清空输入框中的数据
            this.stockcode = '';
            this.buyprice = '';
            return;
          } else {
            this.hide(2);  //关闭弹窗
            this.hide(3);
            //清空输入框中的数据
            this.stockcode = '';
            this.buyprice = '';
          }
        })
      },
      /*发送消息*/
      send: function () {
        /*防止重复提交*/
        if (!$('.submit1').hasClass('speak')) {
          return false;
        }
        $('.submit1').removeClass('speak');
        var question = this.comment;
        var username = this.user.nickname;
        var nickname = this.user.nickname;
        var rid = this.rid;
        var type = 'ask'

        if ($.trim(question).length == 0) {
          this.$dialog.toast({mes: "输入框不能为空", timeout: 1500});
          $('.submit1').addClass('speak');
          return;
        }
        this.$http.post(api.CHAT, {
          question: question,
          username: username,
          nickname: nickname,
          type: type,
          code: '',
          head: '',
          rid: this.rid,
        }).then(function (data) {
          if (data['data']['code'] != 10000) {
            this.$dialog.toast({mes: data['data']['msg'], timeout: 1500});
            $('.submit1').addClass('speak');
            this.comment = '';
            return;
          }
          $('.submit1').addClass('speak');
          this.comment = '';
        })
      },
      /*头像*/
      img_url: function (v) {
        return api.URL + '/' + v;
      },
      //为屏幕设置高度
      setHeight: function () {
        var totalheight = parseFloat($(window).height());
        var headerheight = parseFloat($('.navtab').height());
        var homeheight = totalheight - headerheight
        $('.home').height(homeheight);
        var videoheight = parseFloat($('.zbj').height());
        var tabheigt = parseFloat($('.tab').height());
        var live = $('.liveprompt').hasClass('active');
        if (!live) {
          var commentheight = homeheight - videoheight - tabheigt;
        } else {
          var liveheight = parseFloat($('.liveprompt').height());
          var commentheight = homeheight - videoheight - tabheigt - liveheight;
        }
        $('.program').height(commentheight);
      },
      askShow: function () {
        this.dialogshow = true;
        this.askmarketshow = true;
        $('.zbj').css('margin-top', '-4.4rem')
        //获取设置的行情问题列表
        this.$http.jsonp(api.GETQUESTIONS, {jsonp: 'callback'}).then(function (data) {
          this.questions = data['data'];
        })
      },
      gethis: function () {
        //获取设置的行情问题列表
        this.$http.get(api.HIS + '1').then(function (data) {
          this.videos = data.body.data;
        })
      },
      sharesShow: function () {
        $('.zbj').css('margin-top', '-4.4rem')
        this.dialogshow = true;
        this.stockShow = true;
      },
      hide: function (num) {
        $('.zbj').css('margin-top', '0rem')
        this.dialogshow = false;
        if (num == 1) {
          this.askmarketshow = false;
        } else if (num == 2) {
          this.stockShow = false;
        } else {
          this.fillShow = false;
        }
      },
      fillInCode: function (txt, id) {
        this.question = txt;
        this.id = id;
        this.stockShow = false;
        this.fillShow = true;
      },
      lastStep: function () {
        this.fillShow = false;
        this.stockShow = true;


        //清空输入框中的数据
        this.question = '';
        this.stockcode = '';
        this.buyprice = '';
      }
    },
    mounted: function () {
      /*判断有没有用户信息*/
      var sessionUser = sessionStorage.getItem('user');
      this.user = JSON.parse(sessionUser);
      const roomsinfoString = localStorage.getItem('roomsinfo')
      const roomsinfoObj = JSON.parse(roomsinfoString);
      this.rid = roomsinfoObj.id
      this.roomId = roomsinfoObj.roomid
      $.DW.config({
       userId: 'AE903AFD89036D43',
       roomId: this.roomId,
       recordId: this.id,
       groupId : "",
       viewername: '',
       viewertoken: '',
       isH5play:true,
       fastMode:true
      })
      this.show('1');
      var _this = this;
      let node_name = 'zbjtest/zbjcc/' + roomsinfoObj.path + '/'
      let ref2 = YDCLOUD.ref(node_name + 'classes');
      ref2.get(function (data) {
        let classes = data.nodeContent
        classes.forEach(element => {
          if (element.status == 1) {
            _this.head = 'https://mai-ydgpzbj.ydtg.com.cn' + element.head;
            _this.playtea = element.nickname;
            _this.playtime = element.start + '-' + element.end;
            _this.playclass = element.title;
            _this.status = 3;
            var totalheight = parseFloat($(window).height());
            var headerheight = parseFloat($('.navtab').height());
            var homeheight = totalheight - headerheight;
            var videoheight = parseFloat($('.zbj').height());
            var tabheigt = parseFloat($('.tab').height());
            if (_this.status != 3) {
              var commentheight = homeheight - videoheight - tabheigt;
            } else {
              var liveheight = parseFloat($('.liveprompt').height());
              var commentheight = homeheight - videoheight - tabheigt - liveheight;
            }
            $('.comment').height(commentheight);
          }
        });
      });
      this.setHeight();
      window.onresize = function () {
        _this.setHeight();
      }

      //获取设置的行情问题列表
      this.$http.get(api.GETQUESTIONS + this.rid).then(function (data) {
        this.questions = data['data'];
      })
    }
  }
</script>
<style lang="css" scoped>
  .home {
    overflow: hidden;
  }

  .zbj {
    height: 4.22rem;
    background: #fff;
  }

  .zbj iframe {
    z-index: 10;
  }

  .commentlist li:after, .uinfo .top:after {
    content: "";
    display: block;
    clear: both;
  }

  .tab {
    background: #fff;
  }

  .tablist {
    height: .78rem;
    line-height: .78rem;
  }

  .tablist li {
    float: left;
    width: 33.3%;
    text-align: center;
    font-size: .3rem;
    color: #666;
    border-bottom: 1px solid #E5E5E5;
    position: relative;
  }

  .tablist li.active {
    color: #006ACC;
  }

  .tablist li.active span {
    position: absolute;
    width: .3rem;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    border-bottom: 2px solid #0091FA;
  }

  .comment {
    background: #fff;
    width: 100%;
    overflow-y: scroll;
  }

  .commentlist li {
    padding: .2rem 0;
    margin: 0 .3rem;
    border-bottom: 1px solid #e5e5e5;
  }

  .commentlist li:last-child {
    margin-bottom: 1rem;
  }

  .commentlist li .uhead {
    float: left;
    margin-right: .2rem;
  }

  .commentlist li .uhead img {
    width: .6rem;
    height: .6rem;
  }

  .commentlist li .uinfo {
    float: left;
    width: 87.4%;
  }

  @media screen and (max-width: 300px) {
    .commentlist li .uinfo {
      width: 83.4%;
    }
  }

  .commentlist li .uname {
    font-size: .28rem;
    float: left;
    color: #333;
  }

  .commentlist li .time {
    color: #999;
    float: right;
    font-size: .24rem;
    margin: .1rem 0 .1rem;
  }

  .commentlist li .ucommment {
    color: #666;
    font-size: .26rem;
  }

  .ucommment img {
    display: inline-block;
  }

  .publish {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    max-width: 750px;
    min-width: 300px;
    margin: auto;
    height: .88rem;
    padding: .1rem .2rem;
    background: #F0F0F0;
    z-index: 21;
  }

  .publish .askmarket, .publish .shares {
    display: inline-block;
    width: 14.6%;
    height: .68rem;
    line-height: .68rem;
    text-align: center;
    border-radius: 4px;
    background: #FF435E;
    color: #fff;
    font-size: .3rem;
    margin-right: .1rem;
  }

  .publish .shares {
    background: #FFAB3A;
    margin-right: .3rem;
  }

  .publish input {
    width: 48%;
    height: .68rem;
    background: #fff;
    border: none;
    border-radius: 4px;
    margin-right: .1rem;
    padding: 0 .1rem 0 .3rem;
  }

  .publish .speak {
    position: absolute;
    width: 14.6%;
    height: .68rem;
    line-height: .68rem;
    color: #fff;
    text-align: center;
    background: #61ABF0;
  }

  .program {
    background: #fff;
    padding: 0 .3rem;
    width: 100%;
    overflow-y: auto;
  }

  .programlist li {
    height: 1.24rem;
    margin: 0 .3rem;
    border-bottom: 1px solid #e5e5e5;
  }

  .programlist li div {
    float: left;
  }

  .programlist li .time {
    float: left;
    margin: .5rem .3rem 0 0;
    font-size: .24rem;
  }

  .programlist li .name {
    float: left;
    font-size: .26rem;
    margin-top: .48rem;
  }

  .programlist li .name span {
    margin-right: .3rem;
  }

  .programlist li .back {
    float: right;
    width: 1.2rem;
    height: .48rem;
    line-height: .48rem;
    margin-top: .38rem;
    text-align: center;
    color: #008df8;
    border: 1px solid #A0D0FF;
  }

  .programlist li.live {
    color: #333;
    font-weight: 600;
  }

  .programlist li .living {
    float: right;
    width: 1.2rem;
    height: .48rem;
    line-height: .48rem;
    margin: .38rem 0;
    text-align: center;
    color: #fff;
    background: #fa7b49;
  }

  /**直播提示**/
  .liveprompt {
    height: .8rem;
    background: #f0f0f0;
    padding: 0 .3rem;
    display: none;
  }

  .liveprompt.active {
    display: block;
  }

  .liveprompt .head {
    float: left;
    margin-right: .2rem;
  }

  .liveprompt .head img {
    margin-top: .1rem;
    width: .6rem;
    height: .6rem;
  }

  .liveprompt .text {
    float: left;
    font-size: .2rem;
    margin-top: .1rem;
  }

  .liveprompt .text p img {
    display: inline-block;
    width: .2rem;
    height: .2rem;
    margin-left: .14rem;
  }

  .liveprompt .text p span {
    margin-right: .1rem;
  }

  .liveprompt .text .title {
    font-size: .16rem;
  }

  /**弹框**/
  .layer {
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: rgba(0, 0, 0, .6);
    z-index: 99;
  }

  .askmarket_detail, .consultation_stock, .fillIn {
    width: 5.4rem;
    height: 6rem;
    padding-top: .54rem;
    background: #fff;
    position: absolute;
    bottom: 0;
    top: .5rem;
    left: 0;
    right: 0;
    margin: auto;
    z-index: 100;
    border-radius: 10px;
  }

  .askmarket_detail .title, .consultation_stock .title, .fillIn .title {
    font-size: .36rem;
    color: #666;
    margin-bottom: .5rem;
    text-align: center;
  }

  .askmarket_detail .option, .consultation_stock .option, .fillIn .option {
    width: 4.5rem;
    height: .78rem;
    line-height: .78rem;
    margin: 0 auto .3rem;
    background: #5298EF;
    font-size: .3rem;
    color: #fff;
    border-radius: 10px;
    text-align: center;
  }

  .close .line {
    position: absolute;
    width: 1px;
    height: 1.62rem;
    bottom: -1.62rem;
    left: 0;
    right: 0;
    background: #fff;
    margin: auto;
  }

  .close img {
    position: absolute;
    bottom: -.61rem;
    width: .61rem;
    height: .61rem;
    left: 0;
    right: 0;
    margin: auto;
  }

  .fillIn .input, .fillIn .btn {
    width: 4.5rem;
    height: .78rem;
    margin: 0 auto .1rem;
  }

  .fillIn .input input {
    width: 100%;
    height: 100%;
    border-radius: 10px;
    border: 1px solid #BFBFBF;
    font-size: .3rem;
    padding: .2rem;
    -webkit-appearance: none;
  }

  .fillIn .btn {
    margin: .3rem auto 0;
  }

  .fillIn .btn .previous, .fillIn .btn .sendcode {
    display: inline-block;
    width: 2rem;
    height: .78rem;
    line-height: .78rem;
    border-radius: 10px;
    color: #fff;
    text-align: center;
    background: #B3B3B3;
    font-size: .3rem;
    margin-right: .4rem;
  }

  .fillIn .btn .sendcode {
    margin-right: 0;
    background-color: #5298EF;
  }
</style>



// WEBPACK FOOTER //
// src/views/zb/video.vue